export const requestMethods = {
  get: "get",
  post: "post",
  patch: "patch",
  delete: "delete"
};
